import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { ValidatorForm } from "react-material-ui-form-validator";
import EligibilitySubtitle from "./EligibilitySubtitle/EligibilitySubtitle";
import SkipContentLink from "../../SkipContentLink/SkipContentlink";
import EligibilityQuestions from "./EligibilityQuestions";
import WarningMessage from "../../WarningMessage/WarningMessage";

function FormBuilder(props) {
    const {
        questions,
        answers,
        onFormAnswered,
        formInstructions,
        additionalInstructions,
        requiredFieldsSubtitule,
        subtitleText,
        children,
        handleSubmit,
        customConfig,
        resetValues,
        defaultGridStyles,
        topComponent,
        extraInfoAfterRequired,
        unitValue
    } = props;

    return (
        <ValidatorForm onSubmit={handleSubmit}>
            <SkipContentLink id="ew-content" tabIndex="0">
                Skip to content
            </SkipContentLink>
            <Typography
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                variant="h4"
                tabIndex="0"
                gutterBottom
                id="ew-content"
            >
                {formInstructions}
            </Typography>
            {additionalInstructions &&
                <Typography
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    variant="h6"
                    component="div"
                    tabIndex="0"
                    gutterBottom
                    id="ew-aditional-content"
                >
                    <ul>
                        {additionalInstructions.map((instruction, index) => <li key={'instruction'+index}>{instruction}</li>)}
                    </ul>
                </Typography>
            }
            {
                requiredFieldsSubtitule && subtitleText && (
                <EligibilitySubtitle text={subtitleText} />
            )}
            { topComponent || null }
            {
                requiredFieldsSubtitule && !subtitleText && (
                <Typography variant="h6" tabIndex="0">
                {extraInfoAfterRequired || ""}
                </Typography>
            )}
            <WarningMessage unitLength={unitValue} />
            <Grid container>
              <EligibilityQuestions
                answers={answers}
                questions={questions}
                onFormAnswered={onFormAnswered}
                customConfig={customConfig}
                resetValues={resetValues}
                defaultGridStyles={defaultGridStyles}
              />
            </Grid>
            {children}
        </ValidatorForm>
    );
}

export default FormBuilder;
